import { Controller } from "@hotwired/stimulus";

const getValidUnitOfMeasure = (
  currentUnit,
  defaultProductUnit,
  productEquivalencies
) => {
  if (currentUnit !== "" && currentUnit === defaultProductUnit) {
    return currentUnit;
  }

  if (
    productEquivalencies.find(
      ({ unitOfMeasure }) => currentUnit === unitOfMeasure
    )
  ) {
    return currentUnit;
  }

  return defaultProductUnit;
};

export default class extends Controller {
  static targets = ["product", "productTextField", "quantity"];

  static values = {
    currency: String
  };

  productChanged(e) {
    let [quantity, unitOfMeasure] = this.quantityTarget.value.split(/\s+/);
    quantity = parseFloat(quantity || "1");
    const { unitOfMeasure: defaultUnitOfMeasure, equivalencies } =
      e.detail.selected.dataset;
    unitOfMeasure = getValidUnitOfMeasure(
      unitOfMeasure,
      defaultUnitOfMeasure,
      JSON.parse(equivalencies)
    );

    this.quantityTarget.value = `${quantity} ${unitOfMeasure}`;
  }

  focusProductInput() {
    this.productTextFieldTarget.focus();
  }

  focusLine(e) {
    const target = e.target;
    Array.from(target.parentNode.children).forEach((line) => {
      line.classList.remove("active");
    });
    target.classList.add("active");
  }

  enableDisableFields() {
    const disabled = Boolean(
      !this.productTarget.value || this.productTarget.value === ""
    );
    this.quantityTarget.disabled = disabled;
  }
}
